import { render, staticRenderFns } from "./CharCount.vue?vue&type=template&id=5534ef50&scoped=true&"
import script from "./CharCount.vue?vue&type=script&lang=js&"
export * from "./CharCount.vue?vue&type=script&lang=js&"
import style0 from "./CharCount.vue?vue&type=style&index=0&id=5534ef50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5534ef50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5534ef50')) {
      api.createRecord('5534ef50', component.options)
    } else {
      api.reload('5534ef50', component.options)
    }
    module.hot.accept("./CharCount.vue?vue&type=template&id=5534ef50&scoped=true&", function () {
      api.rerender('5534ef50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/CharCount.vue"
export default component.exports